import { PlanType } from '../types/planType'
import Api, { spoofMode, spoofedUserId } from './api'

export function addPlanId(plan: string, noOfPacks: number) {
  return new Promise<PlanType>((resolve, reject) => {
    Api.post('wwwREST', '/v1/public/signup/customise', { body: { planId: plan, numberOfPacks: noOfPacks } })
      .then(res => resolve(res))
      .catch(err => {
        console.error('Error add plan Id')
        reject(err.message)
      })
  })
}

export function addPlanIdForAccount(subscriptionId: string, plan: string, noOfPacks: number) {
  const url = spoofMode
    ? '/v1/private/admin/account/plan/customise?userId=' + spoofedUserId
    : '/v1/private/account/plan/customise'
  return new Promise<PlanType>((resolve, reject) => {
    Api.post('wwwREST', url, { body: { subscriptionId, planId: plan, numberOfPacks: noOfPacks } })
      .then(res => resolve(res))
      .catch(err => {
        console.error('Error add plan Id for account')
        reject(err.message)
      })
  })
}

export function addNewPlan(body: any) {
  const url = spoofMode ? '/v1/private/admin/account/plan/new?userId=' + spoofedUserId : '/v1/private/account/plan/new'
  return new Promise<PlanType>((resolve, reject) => {
    Api.post('wwwREST', url, { body })
      .then(res => resolve(res))
      .catch(err => {
        console.error('Error add new plan')
        reject(err.message)
      })
  })
}

export function addExistingPlan(body: any) {
  const url = spoofMode
    ? '/v1/private/admin/account/plan/existing?userId=' + spoofedUserId
    : '/v1/private/account/plan/existing'
  return new Promise<PlanType>((resolve, reject) => {
    Api.post('wwwREST', url, { body })
      .then(res => resolve(res))
      .catch(err => {
        console.error('Error add existing plan')
        reject(err.message)
      })
  })
}
